export enum HolidayTypes {
    SCHOOL, PUBLIC, INDIVIDUAL,
}

export const HolidayTypesVue = [
    {
        text: 'Schulferien',
        value: HolidayTypes.SCHOOL,
    },
    {
        text: 'Feiertag',
        value: HolidayTypes.PUBLIC,
    },
    {
        text: 'Standortspezifisch',
        value: HolidayTypes.INDIVIDUAL,
    },
];
